import * as React from 'react';
import Label from './Label';
import { trackEvent } from '../utils/Tracker';
import { Overlay } from '../components/Overlay';

interface Props {
  data: Label;
}

export default class extends React.Component<Props> {
  componentDidMount() {
    const { name } = this.props.data;
    trackEvent('View Record Label Details', { name });
  }
  didClick = (e: React.MouseEvent<HTMLElement>) => {
    const anchor = e.target as HTMLElement;
    trackEvent('View Record Label Link', { type: anchor.dataset.trackid });
  };
  render() {
    const label = this.props.data;
    return (
      <Overlay>
        <div className="label-details">
          <div className="label-details-content">
            <div className="thumb">
              <img
                alt="Label logo"
                src={label.thumbnail}
                crossOrigin="anonymous"
                draggable={false}
              />
            </div>
            <div>
              <h1>{label.name}</h1>
              <div className="bio">{label.bio}</div>
              {label.websiteURL && (
                <a
                  href={label.websiteURL}
                  target="_blank"
                  onClick={this.didClick}
                  data-trackid="website"
                >
                  {label.websiteURL}
                </a>
              )}
              <div className="buttons">
                {label.bookURL !== undefined ? (
                  <>
                    <a
                      className="button large primary"
                      href={label.bookURL}
                      target="_blank"
                      onClick={this.didClick}
                      data-trackid="book"
                    >
                      Book DJ
                    </a>
                    <a
                      className="button large secondary"
                      href={label.buyURL}
                      target="_blank"
                      onClick={this.didClick}
                      data-trackid="buy"
                    >
                      Buy Music
                    </a>
                  </>
                ) : (
                  <a
                    className="button large primary"
                    href={label.buyURL}
                    target="_blank"
                    onClick={this.didClick}
                    data-trackid="buy"
                  >
                    Buy Music
                  </a>
                )}
              </div>
              <div className="social">
                {label.facebookURL && (
                  <a
                    href={label.facebookURL}
                    target="_blank"
                    className="fb"
                    onClick={this.didClick}
                    data-trackid="facebook"
                  >
                    Facebook
                  </a>
                )}
                {label.instagramURL && (
                  <a
                    href={label.instagramURL}
                    target="_blank"
                    className="ig"
                    onClick={this.didClick}
                    data-trackid="instagram"
                  >
                    Instagram
                  </a>
                )}
                {label.twitterURL && (
                  <a
                    href={label.twitterURL}
                    target="_blank"
                    className="tw"
                    onClick={this.didClick}
                    data-trackid="twitter"
                  >
                    Twitter
                  </a>
                )}
                {label.soundcloudURL && (
                  <a
                    href={label.soundcloudURL}
                    target="_blank"
                    className="sc"
                    onClick={this.didClick}
                    data-trackid="soundcloud"
                  >
                    Soundcloud
                  </a>
                )}
                {label.youtubeURL && (
                  <a
                    href={label.youtubeURL}
                    target="_blank"
                    className="yt"
                    onClick={this.didClick}
                    data-trackid="youtube"
                  >
                    YouTube
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </Overlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/audio-editing/LabelDetails.tsx